import React from 'react';
import { useNavigation } from "../contexts/NavigationContext";
import SongLibraryManager from './songs/SongLibraryManager';
import MobileSongLibrary from './MobileSongLibrary';
import SongStateProvider from './songs/SongStateProvider';

/**
 * Responsive wrapper that renders either the desktop or mobile song library
 * based on screen size
 */
const ResponsiveSongLibrary = ({ onCountsUpdate }) => {
  const { isMobile } = useNavigation();

  return (
    <SongStateProvider onCountsUpdate={onCountsUpdate}>
      {isMobile ? (
        <MobileSongLibrary />
      ) : (
        <SongLibraryManager />
      )}
    </SongStateProvider>
  );
};

export default ResponsiveSongLibrary;